// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"76bdb1f1","453":"9124c891","732":"38fad71b"}[chunkId] + ".chunk.js";
};